export default {
    ADMIN: 1,
    SUPPORT: 2,
    ANALYST: 3,
    MANAGER: 4,
    COUNTER_OWNER: 5,
    COUNTER_READONLY: 6,
    USER: 7,
};
